import { MapBounds } from '@/pages/AuctionsNearMe/components/MapView/components/GoogleMap/AuctionsNearMeGoogleMap';

export type GeocodeResult = MapBounds | null;

/**
 * Geocode a location string using Google Maps Geocoding API
 * @param google - Google Maps API object (window.google)
 * @param location - Location string to geocode (e.g., "Cleveland", "Cleveland, OH")
 * @returns Promise that resolves to map bounds or null if geocoding fails
 *
 * @example
 * const bounds = await geocodeLocation(window.google, 'Cleveland');
 * if (bounds) {
 *   // Use bounds.northEast and bounds.southWest
 * } else {
 *   // Geocoding failed
 * }
 */
export const geocodeLocation = (google: typeof window.google | null, location: string): Promise<GeocodeResult> => {
    return new Promise((resolve) => {
        if (!google || !location) {
            resolve(null);
            return;
        }

        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: location }, (results, status) => {
            // Check if geocoding was successful
            if (status !== google.maps.GeocoderStatus.OK || !results || results.length === 0) {
                resolve(null);
                return;
            }

            const { viewport } = results[0].geometry;

            if (!viewport) {
                resolve(null);
                return;
            }

            const ne = viewport.getNorthEast();
            const sw = viewport.getSouthWest();

            resolve({
                northEast: {
                    lat: ne.lat(),
                    lng: ne.lng(),
                },
                southWest: {
                    lat: sw.lat(),
                    lng: sw.lng(),
                },
            });
        });
    });
};
